import React from "react";
import { Recycle, ShieldCheck, HeartHandshake, ArrowRight } from "lucide-react";
import { sustainability } from "../mock";
import Reveal from "./Reveal";

const iconMap = { Recycle, ShieldCheck, HeartHandshake };

export default function Sustainability() {
  return (
    <section id="sustainability" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center mb-14">
          <p className="overline text-sm mb-1">Responsible by design</p>
          <h2 className="section-title text-3xl md:text-5xl">Sustainability</h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {sustainability.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <Reveal key={s.title} delay={i * 100}>
                <div className="card-hover h-full rounded-2xl border border-slate-100 p-8 bg-white flex flex-col">
                  <div className="h-14 w-14 rounded-2xl flex items-center justify-center mb-5" style={{ background: "var(--brand-ice)" }}>
                    {Icon && <Icon size={26} className="text-[color:var(--brand-blue)]" />}
                  </div>
                  <h3 className="font-head font-semibold text-xl mb-3" style={{ color: "var(--brand-navy)" }}>{s.title}</h3>
                  <p className="text-slate-500 leading-relaxed flex-1">{s.desc}</p>
                  <a href="#contact" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--brand-blue)] hover:gap-3 transition-all">
                    Read more <ArrowRight size={15} />
                  </a>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
